import React, { useEffect, useState } from "react";
import RightArrow from "../common/icons/right-arrow";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { _Api } from "../api/_call";
import { loading, Updateloading } from "../common/helpers/toastify";

const isDropboxAccessKey = (key) => {
  const name = String(key || "").trim().toLowerCase().replace(/\s+/g, "_");
  return name === "dropbox_access_token" || name === "access_token";
};

const isDropboxRecord = (item) => String(item?.slag || item?.name || "").toLowerCase() === "dropbox";

const Integratedapplications = () => {
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const { t } = useTranslation();

  const [editItem, setEditItem] = useState(false);
  const [completeDataObject, setCompliteDataObject] = useState();
  const [listdata, setListdata] = useState();
  const [savedata, setSavedata] = useState(false);

  const [clientId, setClientId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [shopUrl, setShopUrl] = useState("");
  const [generatedToken, setGeneratedToken] = useState("");
  const [tokenLoading, setTokenLoading] = useState(false);
  const [showShopifyPopup, setShowShopifyPopup] = useState(false);
  const [showDropboxPopup, setShowDropboxPopup] = useState(false);
  const [dropboxAppKey, setDropboxAppKey] = useState("");
  const [dropboxAppSecret, setDropboxAppSecret] = useState("");
  const [dropboxCode, setDropboxCode] = useState("");
  const [dropboxErrors, setDropboxErrors] = useState({
    appKey: "",
    appSecret: "",
    code: "",
  });
  const [tokenCopied, setTokenCopied] = useState(false);
  const [errors, setErrors] = useState({
    shopUrl: "",
    clientId: "",
    clientSecret: "",
  });

  const getapplicationlist = async () => {
    try {
      let postdata = {};
      let res = await _Api(
        postdata,
        `api/v1/App/applicationkey/get-credentials`,
      );
      if (res?.code === 200) {
        setListdata(res?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getapplicationlist();
  }, []);

  const viewapplication = async (event, data, keys) => {
    try {
      let array = [...listdata];

      if (event) {
        let postdata = { id: data?._id };
        let res = await _Api(
          postdata,
          `api/v1/App/applicationkey/view-credentials`,
        );

        if (res?.code === 200) {
          array[keys].status = 1;
          setListdata(array);
          setEditItem(true);
          setCompliteDataObject(array[keys]);

          // 👉 POPUP OPEN ONLY ONE TIME
          if (
            data?.name === "Shopify" &&
            !data?.client_id &&
            !data?.client_secret
          ) {
            setShowShopifyPopup(true);
          }
          if (String(data?.slag || data?.name || "").toLowerCase() === "dropbox") {
            const record = res?.data || data;
            setCompliteDataObject({ ...record, status: 1 });
            const rows = record?.credentials_Keys || [];
            const hasRefreshToken = rows.some((item) => {
              const name = String(item?.key || "").trim().toLowerCase().replace(/\s+/g, "_");
              return (name === "dropbox_refresh_token" || name === "refresh_token")
                && String(item?.value || "").trim();
            });
            if (!hasRefreshToken) {
              setDropboxAppKey("");
              setDropboxAppSecret("");
              setDropboxCode("");
              setGeneratedToken("");
              setTokenCopied(false);
              setDropboxErrors({ appKey: "", appSecret: "", code: "" });
              setShowDropboxPopup(true);
            } else {
              setShowDropboxPopup(false);
            }
          }
        }
      } else {
        array[keys].status = 0;
        setListdata(array);
        setCompliteDataObject(data);
        setSavedata(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const editapplication = async (completeData) => {
    const finaldata = { ...completeData };
    if (!finaldata?.logo) {
      finaldata.logo =
        "https://gis247.s3.amazonaws.com/2023in0076/User/profile/1713524909925.png";
    }

    finaldata.id = completeData?._id;
    delete finaldata._id;
    delete finaldata.dropbox_first_sync_at;
    delete finaldata.dropbox_sync_hits;
    delete finaldata.dropbox_duration;
    delete finaldata.dropbox_rate_limit;
    delete finaldata.dropbox_image_count;
    if (isDropboxRecord(finaldata) && Array.isArray(finaldata.credentials_Keys)) {
      finaldata.credentials_Keys = finaldata.credentials_Keys.filter(
        (item) => !isDropboxAccessKey(item?.key),
      );
    }
    // delete finaldata.client_id;
    // delete finaldata.client_secret;

    // if (Number(finaldata.status) === 1) {
    //   finaldata.client_id = clientId;
    //   finaldata.client_secret = clientSecret;
    // }
 if (Number(finaldata.status) === 1) {
  if (clientId?.trim() && clientSecret?.trim()) {
    finaldata.client_id = clientId;
    finaldata.client_secret = clientSecret;
  } else {
    // ❗ Do NOT send empty strings
    delete finaldata.client_id;
    delete finaldata.client_secret;
  }
}

    try {
      let GetloadingID = loading();
      let res = await _Api(
        finaldata,
        `api/v1/App/applicationkey/edit-credentials`,
      );

      if (res?.code === 200) {
        setSavedata(false);
        Updateloading(t, GetloadingID, res?.message);
        setEditItem(false);
      }  else if (res?.code === 401 && res?.invalid_credentials) {
        setSavedata(false);
        Updateloading(t, GetloadingID, res?.message, "error");
        setGeneratedToken("");
        setTokenCopied(false);
        if (isDropboxRecord(finaldata)) {
          setDropboxAppKey("");
          setDropboxAppSecret("");
          setDropboxCode("");
          setDropboxErrors({ appKey: "", appSecret: "", code: "" });
          setShowDropboxPopup(true);
        } else {
          setShopUrl("");
          setClientId("");
          setClientSecret("");
          setErrors({ shopUrl: "", clientId: "", clientSecret: "" });
          setShowShopifyPopup(true);
        }
      }else {
        setSavedata(false);
        Updateloading(t, GetloadingID, res?.message || res?.errors, "error");
      }

      getapplicationlist();
      return res;
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (savedata) {
      editapplication(completeDataObject);
    }
    // eslint-disable-next-line
  }, [savedata]);

  const generateDropboxToken = async () => {
    try {
      const nextErrors = {
        appKey: dropboxAppKey.trim() ? "" : "App key is required",
        appSecret: dropboxAppSecret.trim() ? "" : "App secret is required",
        code: dropboxCode.trim() ? "" : "Authorization code is required",
      };
      if (nextErrors.appKey || nextErrors.appSecret || nextErrors.code) {
        setDropboxErrors(nextErrors);
        return;
      }
      setDropboxErrors({ appKey: "", appSecret: "", code: "" });
      setTokenLoading(true);
      const res = await _Api(
        {
          client_id: dropboxAppKey.trim(),
          client_secret: dropboxAppSecret.trim(),
          code: dropboxCode.trim(),
        },
        `api/v1/App/applicationkey/generate-dropbox-token`,
      );
      if (res?.success && res?.token) {
        setGeneratedToken(res.token);
        setCompliteDataObject((state) => {
          if (!state?.credentials_Keys) return state;
          return {
            ...state,
            credentials_Keys: state.credentials_Keys.map((item) => {
              const key = String(item?.key || "").trim().toLowerCase().replace(/\s+/g, "_");
              if (key === "dropbox_app_key" || key === "app_key") return { ...item, value: dropboxAppKey.trim() };
              if (key === "dropbox_app_secret" || key === "app_secret") return { ...item, value: dropboxAppSecret.trim() };
              if (key === "dropbox_refresh_token" || key === "refresh_token") return { ...item, value: res.token };
              if (key === "dropbox_access_token" || key === "access_token") return { ...item, value: "" };
              return item;
            }),
          };
        });
      } else {
        setDropboxErrors((state) => ({
          ...state,
          code: res?.message || "Dropbox token generation failed",
        }));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setTokenLoading(false);
    }
  };

  const generateShopifyToken = async () => {
    try {
      let newErrors = {
        shopUrl: "",
        clientId: "",
        clientSecret: "",
      };

      if (!shopUrl?.trim()) newErrors.shopUrl = "Shopify domain is required";
      if (!clientId?.trim()) newErrors.clientId = "Client ID is required";
      if (!clientSecret?.trim())
        newErrors.clientSecret = "Client Secret is required";

      if (newErrors.shopUrl || newErrors.clientId || newErrors.clientSecret) {
        setErrors(newErrors);
        return;
      }

      setErrors({ shopUrl: "", clientId: "", clientSecret: "" });

      setTokenLoading(true);

      let postdata = {
        client_id: clientId,
        client_secret: clientSecret,
        shop_url: shopUrl,
      };

      let res = await _Api(
        postdata,
        `api/v1/App/applicationkey/generate-token`,
      );
      
      if (res?.success) {
        setGeneratedToken(res?.token);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setTokenLoading(false);
    }
  };

  const copyToken = async () => {
    try {
      if (!generatedToken) return;

      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(generatedToken);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = generatedToken;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      setTokenCopied(true);
      setTimeout(() => setTokenCopied(false), 2000);
    } catch (e) {
      console.error("Clipboard error:", e);
    }
  };
  console.log(tokenLoading, "tokenLoading");
  return (
    <>
      {showDropboxPopup && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontSize: "19px", fontWeight: 600 }}>
                  Generate Dropbox Token
                </h5>
                <button className="btn-close" onClick={() => setShowDropboxPopup(false)} />
              </div>
              <div className="modal-body">
                <div className="v3-input-group mb-3">
                  <label className="v3-input-group-label">App Key</label>
                  <input
                    className="v3-input-group-input w-100"
                    value={dropboxAppKey}
                    onChange={(e) => {
                      setDropboxAppKey(e.target.value);
                      setDropboxErrors({ ...dropboxErrors, appKey: "" });
                    }}
                  />
                  {dropboxErrors.appKey && <small className="text-danger">{dropboxErrors.appKey}</small>}
                </div>
                <div className="v3-input-group mb-3">
                  <label className="v3-input-group-label">App Secret</label>
                  <input
                    className="v3-input-group-input w-100"
                    value={dropboxAppSecret}
                    onChange={(e) => {
                      setDropboxAppSecret(e.target.value);
                      setDropboxErrors({ ...dropboxErrors, appSecret: "" });
                    }}
                  />
                  {dropboxErrors.appSecret && <small className="text-danger">{dropboxErrors.appSecret}</small>}
                </div>
                <div className="v3-input-group mb-3">
                  <label className="v3-input-group-label">Authorization Code</label>
                  <input
                    className="v3-input-group-input w-100"
                    value={dropboxCode}
                    onChange={(e) => {
                      setDropboxCode(e.target.value);
                      setDropboxErrors({ ...dropboxErrors, code: "" });
                    }}
                  />
                  {dropboxErrors.code && <small className="text-danger">{dropboxErrors.code}</small>}
                  <button
                    type="button"
                    className="btn btn-link px-0"
                    disabled={!dropboxAppKey.trim()}
                    onClick={() => {
                      const url = `https://www.dropbox.com/oauth2/authorize?client_id=${encodeURIComponent(dropboxAppKey.trim())}&response_type=code&token_access_type=offline`;
                      window.open(url, "_blank", "noopener,noreferrer");
                    }}
                  >
                    Open Dropbox Allow
                  </button>
                </div>
                <div className="d-flex gap-2 align-items-center justify-content-end">
                  <button
                    className="btn btn-primary"
                    style={{ background: "#5cc7c1", border: "unset" }}
                    disabled={tokenLoading}
                    onClick={generateDropboxToken}
                  >
                    {tokenLoading ? "Generating..." : "Generate Token"}
                  </button>
                  <button className="btn btn-secondary" onClick={() => setShowDropboxPopup(false)}>
                    Close
                  </button>
                </div>
              </div>
              <div className="modal-footer w-100">
                {generatedToken && (
                  <div className="mt-6 w-100 d-flex align-items-center justify-content-between">
                    <span className="fs-6" style={{ color: "red", wordBreak: "break-all" }}>
                      {generatedToken}
                    </span>
                    <button
                      className="btn btn-success w-30"
                      onClick={() => {
                        copyToken();
                        setTimeout(() => setShowDropboxPopup(false), 3000);
                      }}
                    >
                      {tokenCopied ? "Copied!" : "Copy Token"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {showShopifyPopup && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  style={{ fontSize: "19px", fontWeight: 600 }}
                >
                  Generate Shopify Token
                </h5>
                <button
                  className="btn-close"
                  onClick={() => setShowShopifyPopup(false)}
                />
              </div>

              <div className="modal-body">
                <div className="v3-input-group mb-3">
                  <label className="v3-input-group-label">Shopify Domain</label>
                  <input
                    className="v3-input-group-input w-100"
                    value={shopUrl}
                    onChange={(e) => {
                      setShopUrl(e.target.value);
                      setErrors({ ...errors, shopUrl: "" });
                    }}
                  />
                  {errors.shopUrl && (
                    <small className="text-danger">{errors.shopUrl}</small>
                  )}
                </div>
                <div className="v3-input-group mb-3">
                  <label className="v3-input-group-label">Client ID</label>
                  <input
                    className="v3-input-group-input w-100"
                    value={clientId}
                    onChange={(e) => {
                      setClientId(e.target.value);
                      setErrors({ ...errors, clientId: "" });
                    }}
                  />
                  {errors.clientId && (
                    <small className="text-danger">{errors.clientId}</small>
                  )}
                </div>

                <div className="v3-input-group mb-3">
                  <label className="v3-input-group-label">Client Secret</label>
                  <input
                    className="v3-input-group-input w-100"
                    value={clientSecret}
                    onChange={(e) => {
                      setClientSecret(e.target.value);
                      setErrors({ ...errors, clientSecret: "" });
                    }}
                  />
                  {errors.clientSecret && (
                    <small className="text-danger">{errors.clientSecret}</small>
                  )}
                </div>

                <div className="d-flex gap-2 align-items-center justify-content-end">
                  <button
                    className="btn btn-primary"
                    style={{ background: "#5cc7c1", border: "unset" }}
                    disabled={tokenLoading}
                    onClick={generateShopifyToken}
                  >
                    {tokenLoading ? "Generating..." : "Generate Token"}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowShopifyPopup(false)}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="modal-footer w-100">
                {generatedToken && (
                  <div className="mt-6 w-100 d-flex align-items-center justify-content-between">
                    <span className="fs-6" style={{ color: "red" }}>
                      {generatedToken}
                    </span>
                    <button
                      className="btn btn-success w-30"
                      onClick={() => {
                        copyToken();
                        setTimeout(() => setShowShopifyPopup(false), 3000);
                      }}
                    >
                      {tokenCopied ? "Copied!" : "Copy Token"}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-wrapper-body">
        <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
          <div className="main-content-wrapper-body-top-bar-left">
            <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
              <Link className="text-decoration-none" to="/app/admin/settings">
                {t("Setting")}
              </Link>{" "}
              <RightArrow />{" "}
              <span className="">{t("Integrated Applications")}</span>
            </h1>
          </div>
        </div>

        <div className="row">
          <div className={editItem ? "col-md-6" : "col-md-12"}>
            <div className="main-body-main-table-wrap com-custom-table table-responsive position-relative">
              <table
                id="my_customer"
                className="com-custom-table-tag table align-middle"
              >
                <thead>
                  <tr className="text-nowrap align-middle">
                    <th>#</th>
                    <th>{t("Image")}</th>
                    <th>{t("Name")}</th>
                    <th>{t("Type")}</th>
                    <th>{t("Article")}</th>
                    <th>{t("Action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {listdata?.length &&
                    listdata.map((result, key) => (
                      <tr className="text-nowrap" key={key}>
                        <td>{key + 1}</td>
                        <td className="px-2">
                          <img
                            className="table-user-img rounded-circle"
                            src={result?.logo}
                            alt=""
                          />
                        </td>
                        <td>
                          {result?.status ? (
                            <span
                              onClick={(e) =>
                                viewapplication(true, result, key)
                              }
                              className="link-color cursor-pointer"
                            >
                              {result?.name}
                            </span>
                          ) : (
                            <span>{result?.name}</span>
                          )}
                        </td>
                        <td>{result?.type}</td>
                        <td>
                          {result?.instructions ? (
                            <a
                              href={result?.instructions}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="25"
                                viewBox="0 0 22 25"
                                fill="none"
                              >
                                <path
                                  id="Vector"
                                  d="M20.7778 24.7218H1.22222C0.898069 24.7218 0.587192 24.593 0.357981 24.3638C0.128769 24.1346 0 23.8237 0 23.4996V1.49957C0 1.17541 0.128769 0.864535 0.357981 0.635324C0.587192 0.406113 0.898069 0.277344 1.22222 0.277344H20.7778C21.1019 0.277344 21.4128 0.406113 21.642 0.635324C21.8712 0.864535 22 1.17541 22 1.49957V23.4996C22 23.8237 21.8712 24.1346 21.642 24.3638C21.4128 24.593 21.1019 24.7218 20.7778 24.7218ZM19.5556 22.2773V2.72179H2.44444V22.2773H19.5556ZM4.88889 5.16623H9.77778V10.0551H4.88889V5.16623ZM4.88889 12.4996H17.1111V14.944H4.88889V12.4996ZM4.88889 17.3885H17.1111V19.8329H4.88889V17.3885ZM12.2222 6.38845H17.1111V8.8329H12.2222V6.38845Z"
                                  fill="#606060"
                                />
                              </svg>
                            </a>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <div className="col-md-3 pe-0">
                            <div className="form-check form-switch ps-0">
                              <label
                                className="form-check-label"
                                htmlFor="mixmatch"
                              ></label>
                              <input
                                className="form-check-input float-none ms-2"
                                type="checkbox"
                                id="mixmatch"
                                checked={result?.status}
                                onChange={(e) =>
                                  viewapplication(e.target.checked, result, key)
                                }
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className={editItem ? "col-md-6 d-block" : "d-none"}>
            <div className="edit-item-area bg-white row">
              <div className="col-md-9 px-0">
                <div className="edit-item-area-body">
                  <div className="edit-item-area-body-circle-img text-center mb-4">
                    <div className="edit-item-area-body-circle-img-choose">
                      <input
                        id="chooseImg"
                        type="file"
                        className="d-none"
                        accept="image/*"
                      />
                      <label
                        htmlFor="chooseImg"
                        className="rounded-circle overflow-hidden"
                      >
                        <img
                          className=""
                          src={
                            completeDataObject?.logo
                              ? completeDataObject?.logo
                              : base_assets + "images/blank-img-2.png"
                          }
                          alt=""
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 ps-0">
                      <div className="row mx-0">
                        <div className="col-md-12">
                          {completeDataObject?.credentials_Keys?.length
                            ? completeDataObject?.credentials_Keys.map(
                                (result, key) => (
                                  isDropboxRecord(completeDataObject) && isDropboxAccessKey(result?.key) ? null :
                                  <div className="v3-input-group" key={key}>
                                    <label className="v3-input-group-label">
                                      {result?.key}
                                      <sup>*</sup>
                                    </label>
                                    <input
                                      onChange={(e) => {
                                        const newValue = e.target.value;
                                        setCompliteDataObject((state) => ({
                                          ...state,
                                          credentials_Keys:
                                            state.credentials_Keys.map(
                                              (item, index) => {
                                                if (index === key) {
                                                  return {
                                                    ...item,
                                                    value: newValue,
                                                  };
                                                } else {
                                                  return item;
                                                }
                                              },
                                            ),
                                        }));
                                      }}
                                      value={result?.value}
                                      type="text"
                                      className="v3-input-group-input w-100"
                                    />
                                  </div>
                                ),
                              )
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-3 pe-0">
                <div className="edit-item-area-header d-flex align-items-center justify-space-between mb-4">
                  <button
                    className="square-btn square-btn-white btn-close focus-none"
                    onClick={() => {
                      setEditItem(false);
                      getapplicationlist();
                    }}
                  ></button>
                  <button
                    className="square-btn"
                    onClick={() => setSavedata(true)}
                  >
                    <img
                      src={base_assets + "images/icons/white-save.png"}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Integratedapplications;
